





















































































































































































































import Component, { mixins } from 'vue-class-component'
import Card from '@/components/Card.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import { PaymentsModule } from '@/store/modules/payments.module'
import { getModule } from 'vuex-module-decorators'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import PaginationV2 from '@/components/tables/PaginationV2.vue'
import { EAutoPaySettingStatus } from '@zunta/configurations'
import Icon from '@/components/Icon.vue'
import { EAutoPayType, IAutoPaySetting } from '@zunta/configurations/dist/types/payments'
import NoData from '@/views/app/management/residents/NoData.vue'
import StatusAutoPaymentSetting from '@/components/statuses/StatusAutoPaymentSetting.vue'
import { ResidentPageMixin } from '@/views/app/management/residents/resident-page/ResidentPageMixin'
import PaymentMethodLabel from '@/components/labels/PaymentMethodLabel.vue'

@Component({
  components: {
    PaymentMethodLabel,
    StatusAutoPaymentSetting,
    Icon,
    PaginationV2,
    LoaderWrapper,
    NoData,
    DateTimeLabel,
    Card
  }
})
export default class ResidentAutoPaymentWidget extends mixins(ResidentPageMixin) {
  paymentsModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store)
  EAutoPaySettingStatus: any = EAutoPaySettingStatus
  EAutoPayType: any = EAutoPayType
  isLoading: boolean = false
  skip: number = 0

  get residentId () {
    return this.$route.params.id
  }

  get autoPaySettings () {
    return this.$store.state.payments.autoPaySettings
      .filter((setting: IAutoPaySetting) => setting.status === EAutoPaySettingStatus.ACTIVE)
  }

  get autoPaySettingsTotal () {
    return this.autoPaySettings.length ? this.autoPaySettings.length : 0
  }

  get autoPaySettingsSlice () {
    if (!this.autoPaySettings || !this.autoPaySettings.length) {
      return null
    }
    return this.autoPaySettings[this.skip]
  }

  mounted () {
    this.fetchData()
    this.$watch('residentId', () => this.fetchData())
  }

  changePage (event: any) {
    this.skip = event
  }

  getAutoPayType (type: EAutoPayType) {
    const TYPE_LABELS: any = {
      [EAutoPayType.BILL_MAX_ONLY]: 'Values are Up to Max Amount',
      [EAutoPayType.BILL_ANYWAY]: 'Fixed amount',
      [EAutoPayType.BILL_MONTH_DUE]: 'Monthly balance',
      [EAutoPayType.BILL_FULL_DUE]: 'Full balance'
    }
    return TYPE_LABELS[type]
  }

  async fetchData () {
    try {
      this.isLoading = true
      this.skip = 0
      await this.paymentsModuleInstance.fetchResidentAutoPaySettings({ resident: this.residentId })
    } finally {
      this.isLoading = false
    }
  }

  getDayLabel (dayOfMonth: number) {
    const getFirstThreeOrdinals = function (num: string) {
      switch (num) {
        case '1':
          return 'st'
        case '2':
          return 'nd'
        case '3':
          return 'rd'
      }
    }
    if (dayOfMonth <= 0 && dayOfMonth > 31) {
      return 'N/A'
    }

    let label = dayOfMonth.toString()

    if (dayOfMonth >= 1 && dayOfMonth <= 3) {
      label += getFirstThreeOrdinals(dayOfMonth.toString())
    } else if ((dayOfMonth >= 21 && dayOfMonth <= 23) || dayOfMonth === 31) {
      let split_num = label.split('')
      label += getFirstThreeOrdinals(split_num[1])
    } else {
      label += 'th'
    }

    if (dayOfMonth >= 28) {
      label += ' or last day of month'
    }
    return label
  }
}
